import React, { useEffect, useState } from "react";
import { Dropdown, Menu } from "antd";
import { formatPhoneNumberForDisplay } from "../../../util/helpers";
import IntlMessages from "../../../util/IntlMessages";
import whatsappIcon from "../../../assets/images/whatsapp.svg";
import "./SelectSender.less";

const SelectSender = ({
                          selectedValue,
                          senderList,
                          updateSenderNumber,
                      }) => {
    const [normalizedSenderList, setNormalizedSenderList] = useState();

    useEffect(() => {
        if (!senderList) {
            return;
        }

        setNormalizedSenderList(
            senderList.reduce((acc, phoneNumber) => {
                if (phoneNumber.capabilities?.includes("sms")) {
                    acc.push({
                        ...phoneNumber,
                        channel: "sms",
                    });
                }

                if (phoneNumber.capabilities?.includes("whatsapp")) {
                    acc.push({
                        ...phoneNumber,
                        number: `${phoneNumber.number}-whatsapp`,
                        channel: "whatsapp",
                        isWhatsappSender: true,
                    });
                }

                return acc;
            }, [])
        );
    }, [senderList]);

    const handleSelect = ({key}) => {
        const sender = normalizedSenderList[key];
        updateSenderNumber(sender.number);
    };

    const senders = () => (
        <Menu onClick={handleSelect}>
            {normalizedSenderList?.map((option, index) => (
                <Menu.Item key={index}>
                  <span className="sender">
                    <span>
                      {option.customName ||
                          formatPhoneNumberForDisplay(
                              option.number.replace("-whatsapp", "")
                          )}
                    </span>

                      {option.isWhatsappSender && (
                          <img
                              src={whatsappIcon}
                              alt="WhatsApp"
                              className="whatsapp-icon"
                          />
                      )}
                  </span>
                </Menu.Item>
            ))}
        </Menu>
    );

    const getSelectedSender = () => {
        if (selectedValue) {
            return normalizedSenderList?.find(
                sender => sender.number === selectedValue
            );
        }

        if (!normalizedSenderList) {
            return null;
        }

        return normalizedSenderList.find(sender => sender.isDefault) || null;
    };

    const selectedSender = getSelectedSender();

    return (
        <Dropdown
            className="select-sender"
            overlay={senders()}
            placement="topCenter"
            trigger={["click"]}
        >
            <div className="sender hover-pointer">
                <span className="mobile-hide">
                  <IntlMessages id="chats.sender"/>:
                </span>

                <p>
                    {selectedSender &&
                        (selectedSender.customName ||
                            formatPhoneNumberForDisplay(
                                selectedSender.number.replace("-whatsapp", "")
                            ))}

                    {selectedSender?.isWhatsappSender && (
                        <img
                            src={whatsappIcon}
                            alt="WhatsApp"
                            className="whatsapp-icon"
                        />
                    )}
                </p>

                <i className="gx-icon-btn icon icon-menu-down z-index-2 no-hover-action"/>
            </div>
        </Dropdown>
    );
};

export default SelectSender;
